// autolayout/logos - S48.2a.
// resolverLogos(marcaString, logosConfig)
//   - marcaString: string (ej. "MAZDA"). Puede contener varias marcas
//     separadas por "/", ",", " - " (compat con compatibilidad multi-marca).
//   - logosConfig: mapa { MARCA: 'archivo.svg' }.
//   Retorna Array<{ type: 'img'|'tag', label: string, src?: string }>
//
//   - Si la marca tiene entrada en logosConfig -> { type: 'img', src, label }.
//   - Si la marca NO tiene entrada -> { type: 'tag', label } (TAG DE TEXTO).
//
// La funcion siempre devuelve ARRAY (puede tener 0..N elementos).

function _parseMarcas(marcaString) {
  if (!marcaString) return [];
  const s = String(marcaString).toUpperCase();
  const parts = s.split(/\s*[/,]\s*|\s+-\s+/);
  const out = [];
  for (let i = 0; i < parts.length; i += 1) {
    const p = parts[i].trim();
    if (p) out.push(p);
  }
  return out;
}

export function resolverLogos(marcaString, logosConfig) {
  const marcas = _parseMarcas(marcaString);
  const cfg = logosConfig || {};
  const seen = {};
  const out = [];
  for (let i = 0; i < marcas.length; i += 1) {
    const m = marcas[i];
    if (seen[m]) continue;
    seen[m] = true;
    if (Object.prototype.hasOwnProperty.call(cfg, m) && cfg[m]) {
      out.push({ type: 'img', label: m, src: cfg[m] });
    } else {
      out.push({ type: 'tag', label: m });
    }
  }
  return out;
}

// Helper para uso desde dynamicFields: aplana logos resueltos a string
// para mostrar en el field cuando el render sigue siendo type='text'.
export function logosToText(logos) {
  if (!Array.isArray(logos) || logos.length === 0) return '';
  const parts = [];
  for (let i = 0; i < logos.length; i += 1) {
    const l = logos[i];
    if (l && l.label) parts.push(String(l.label));
  }
  return parts.join(' \u00B7 ');
}
